module.exports = __webpack_public_path__ + "assets/img/castrol+bosth.7cc4f689.png";